<style scoped lang="less">
	/deep/ .el-radio__input.is-checked .el-radio__inner {
		border-color: #07B446;
		background: #07B446;
	}

	/deep/ .el-radio__input.is-checked+.el-radio__label {
		color: #333;
	}

	@media (min-width: 768px) and (max-width:991px) {

		.col-md-12 {
			margin-top: 1rem;
			border-left: 0px !important;

			.userheadertx {
				width: 15vw !important;
				height: 15vw !important;

			}


			.qmedit {

				// width: 80%;
				input {
					width: 80%;
				}

			}


		}
	}


	@media (min-width: 576px) {
		// .col-md-12.usertexts {
		// 	border-left: 0 !important;
		// }

		.col-sm-12 {
			.userheadertx {
				width: 15vw !important;
				height: 15vw !important;
			}

			// .usertext {
			// 	margin-top: 1rem;
			// }

		}
	}



	@media (min-width: 992px) {
		.col-lg-3.usertexts {
			margin-top: 0 !important;
			border-left: 15px solid #EFF2FA;
		}

		.col-lg-3 {
			.userheadertx {
				width: 6vw !important;
				height: 6vw !important;

			}



		}
	}








	.userx {
		width: 100%;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		flex-wrap: wrap;

		.usercards {
			background: #fff;
			// border: 1px solid;
			border-radius: 7px;

			img.usercardbg {
				width: 100%;
			}

			.usercard {
				width: 100%;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				align-content: center;

				/* 设置持续时间和动画函数 */
				.v-enter-active,
				.v-leave-active {
					transition: all .8s ease;
				}

				.v-enter,
				.v-leave-to {
					transform: translateX(100px);
					opacity: 0;
				}



				.userheader {
					text-align: center;
					width: 100%;
					padding: 0 0.8rem;
					box-sizing: border-box;

					img {
						position: relative;
						left: 0;
						top: -4rem;
						width: 6vw;
						height: 6vw;
					}

					span.pens {
						display: block;
						position: relative;
						width: 2rem;
						height: 2rem;
						border-radius: 50%;
						border: 1px solid;
						display: flex;
						align-items: center;
						justify-content: center;
						background: #0ACF97;
						color: #fff;
						font-size: 1rem;
						font-weight: 800;
						left: 60%;
						top: -6rem;
					}

					.usercardts {
						position: relative;
						top: -5rem;
						width: 100%;

						.name {
							font-size: 1rem;
							color: #333;
						}

						.student {
							margin: 0.8rem 0;
							color: #FF8300;
							font-size: 0.8rem;

						}

						.qma {
							width: 100%;
							// text-align: left;
							overflow: inherit;
							white-space: inherit;
							text-overflow: inherit;
						}

						.qmedit {
							margin-top: 1rem;
							display: flex;
							align-items: center;
							justify-content: center;


							input {

								border: 1px solid #5891AA;
								border-radius: 10rem;
								padding: 0.4rem 0.4rem;
								box-sizing: border-box;

							}

							span {
								cursor: pointer;
								margin: 0 0.4rem;
								font-size: 1rem;
								border-radius: 50%;
							}

							span:nth-of-type(1) {
								color: #fff;
								background: #55ff7f;
							}

							span:nth-of-type(2) {
								color: #fff;
								background: #ff4621;
							}
						}

						.editqm:hover {
							background-color: #ececec;
						}

						.editqm {
							margin-top: 1.5rem;
							border: 1px solid #5891AA;
							padding: 0.4rem 0.8rem;
							border-radius: 5px;

							span {
								font-weight: 800;
							}
						}


					}
				}
			}
		}
	}


	.usertexts {
		border-left: 15px solid #EFF2FA;

		.usertext {
			padding: 1rem 2rem;
			background: #fff;
			border-radius: 5px;
		}

		.sex {
			/deep/ label {
				margin-bottom: 0 !important;
			}
		}


		.useript {
			label {
				display: block;
				margin-bottom: 1rem;

				p {
					margin-bottom: 0.4rem;
				}
			}

			.save {
				background: #0ACF97;
				color: #fff;
				padding: 0.6rem 2rem;
				border-radius: 5px;
			}
			
			.save:hover{
				background: #0beeaa; 
			}

			.ouone {
				width: 35vw;
				text-align: center;
				margin: 1rem 0;

				span {
					display: block;
					padding: 4rem;
					font-size: 7rem;
					color: #ccc;
					border: 1px dashed #ccc;
				}
			}
		}




		ul {
			display: flex;
			align-items: center;
			margin-bottom: 1rem;

			li {
				width: 15%;
				text-align: center;
				height: 2rem;
				line-height: 2rem;
			}

			li.usertexttext {
				background-color: #5891AA;
				color: #fff;
				font-size: 0.8rem;
				border-radius: 5px;

			}
		}
	}

	.form-control {
		font-weight: 500;
	}
	.tsleiou{
		/* 设置持续时间和动画函数 */
		.v-enter-active,
		.v-leave-active {
			transition: all .8s ease;
		}
		
		.v-enter,
		.v-leave-to {
			transform: translateX(-100px);
			opacity: 0;
		}
	}
	
</style>


<template>
	<div>
		<titles titlename="个人信息" titlecontent="这里可以编辑个人信息" :mbx="paths"></titles>
		<div class="userx">
			<div class="usercards col-xs-12 col-sm-12 col-md-12 col-lg-3">
				<div class="usercard">
					<img class="usercardbg" src="./../../images/userbg.svg" alt="">
					<div class="userheader" style="height: 24vh;">
						<img class="userheadertx" src="../../images/userheader.svg" alt="" @click="getheadertx()">
						<input type="file" ref="file" @change="preview" accept=".png,.jpg"  style="display: none">
						<span class="el-icon-edit pens"></span>
						<div class="usercardts">
							<p class="name">胡歌</p>
							<p class="student">学员 &nbsp;&nbsp;普通用户</p>
							<div class="qma">
								我们终将重逢，在旅途的终点见吧！
								<transition>
									<div class="qmedit" v-if="qmedit==1">
										<input type="text">
										<span class="el-icon-check" @click="qmedit=0"></span>
										<span class="el-icon-close" @click="qmedit=0"></span>
									</div>
								</transition>
							</div>
							<transition class="tsleiou">
								<button class="editqm" v-if="qmedit==0" @click="qmedit=1">
									<span class="el-icon-edit"></span>
									编辑签名
								</button>
							</transition>
						</div>
					</div>

				</div>
			</div>
			<div class="usertexts col-xs-12 col-sm-12 col-md-12 col-lg-9">
				<div class="usertext">
					<ul>
						<li :class="{'usertexttext':usertabnam==1}" @click="usertabnam=1">
							个人信息
						</li>
						<li :class="{'usertexttext':usertabnam==2}" @click="usertabnam=2">
							修改密码
						</li>
						<li :class="{'usertexttext':usertabnam==3}" @click="usertabnam=3">
							个性背景
						</li>
					</ul>

					<div class="useript" v-if="usertabnam==1">
						<form>
							<label>
								<p>用户名</p>
								<input type="text" class="form-control" placeholder="请输入用户名">
							</label>
							<label>
								<p>真实姓名</p>
								<input type="text" class="form-control" placeholder="请输入真实姓名">
							</label>
							<label>
								<p>学号</p>
								<input type="text" class="form-control" placeholder="请输入学号">
							</label>
							<label class="sex">
								<p>性别：</p>
								<div style="display: flex;align-items: center;">
									<el-radio v-model="radio" label="1">男</el-radio>
									&nbsp;&nbsp;&nbsp;&nbsp;
									<el-radio v-model="radio" label="2">女</el-radio>
								</div>
							</label>
							<label>
								<p>手机号码</p>
								<input type="tel" class="form-control" placeholder="请输入手机号码">
							</label>
							<label>
								<p>邮箱地址</p>
								<input type="email" class="form-control" placeholder="请输入邮箱地址">
							</label>
							<label>
								<p>所属学院</p>
								<select class="form-control" id="exampleFormControlSelect1">
									<option>柳州铁道职业技术学院</option>
									<option>中南林科大</option>
									<option>湖南铁道学院</option>
								</select>
							</label>
							<label>
								<p>所属专业</p>
								<select class="form-control" id="exampleFormControlSelect1">
									<option>铁路</option>
									<option>铁壳</option>
									<option>硬铁壳</option>
								</select>
							</label>
							<button type="button" class="save">保存</button>
						</form>
					</div>

					<div class="useript" v-if="usertabnam==2">
						<form>
							<label>
								<p>原密码</p>
								<input type="text" class="form-control" placeholder="请输入原密码">
							</label>
							<label>
								<p>新密码</p>
								<input type="text" class="form-control" placeholder="请输入新密码">
							</label>
							<label>
								<p>再次输入新密码</p>
								<input type="text" class="form-control" placeholder="再次输入新密码">
							</label>

							<button type="button" class="save">保存</button>
						</form>
					</div>

					<div class="useript" v-if="usertabnam==3">
						<p>上传个性背景</p>
						<div class="ouone" @click="getheadertx1()">
							<span class="el-icon-camera-solid"></span>
							<input type="file" ref="file1" @change="preview1" accept="image/*" style="display: none">
						</div>
						<button type="button" class="save">保存</button>
					</div>


				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import titles from "@/components/title/title.vue"


	export default {
		data() {
			return {
				usertabnam: 1,
				radio: "1",
				// 标题组件
				paths: [{
					path: "user/ChangeUser",
					name: "个人信息"
				}],
				// 编辑签名
				qmedit: 0,
				img: ""
			}
		},
		created() {

		},
		updated() {


		},
		methods: {
			getheadertx() {
				this.$refs.file.click()
			},
			preview: function(e) {
				let _this = this;
				let file = e.target.files[0]
				if (!file) {
					return
				}
				var imgs = ""
				var reader = new FileReader()
				reader.readAsDataURL(e.target.files[0])
				reader.onload = function() {
					imgs = this.result
					_this.img = imgs
					_this.upload(imgs)
				}


			},
			upload(img) {
				console.log(img)
			},
			getheadertx1() {
				this.$refs.file1.click()
			},
			preview1(e) {
				console.log(e.target.files[0])
			}



		},
		components: {
			titles
		}

	}
</script>
